import styled from '@emotion/styled'
import { cartMQ } from 'theme/mediaQueries'
import { css } from '@emotion/react'

export const warning = css`
  border: dashed 1px #ee7d7d;
  border-radius: 10px;
`

export const ItemContainer = styled.div`
  border-bottom: solid 1px rgb(240, 240, 240);
  padding-bottom: 10px;
  margin-left: -30px;
  margin-right: -30px;
`

export const InfoContainer = styled.div`
  padding: 0 30px;
  grid-template-columns: auto 510px;

  ${cartMQ({
    display: ['block', 'block', 'block', 'grid'],
  })}

  .qtt-value {
    display: grid;

    ${cartMQ({
      gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '60px 130px'],
    })}
  }

  .item-attributes {

    ${cartMQ({
      display: ['block', 'block', 'grid', 'grid'],
      gridTemplateColumns: ['1fr 1fr', '1fr 1fr', 'auto auto 60px', '190px 260px 60px'],
    })}
  }

  .values {
    display: grid;

    ${cartMQ({
      gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '130px 130px'],
    })}
  }
`

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;

  button {
    height: 30px;
  }

  ${cartMQ({
    justifyContent: ['left', 'left', 'left', 'space-between'],
  })}
`
